import axios from 'axios';
import { norebaseUrl } from './constants';
import { registerNetcoreActivity } from './registerActivity';
import jwtDecode from 'jwt-decode';

export const checkNamefn = async (
  setter: any,
  bussName: string,
  setter2: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setError: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const token: any = localStorage.getItem('login-token');
  const details: any = jwtDecode(token);
  setError(false);
  setLoading(true);
  axios
    .get(`${norebaseUrl}?businessName=${bussName}`)
    .then((res) => {
      setLoading(false);
      if (!res.data.result.length) {
        setter({});
        // IF THERE ARE NO COMPANIES WITH THE SAME NAME
        // SET CHECKS TO FALSE COS IF CHECK IS TRUE
        // IT MEANS THE NAME HAS NOT BEEN USED BEFORE
        setter2(true);
      } else if (res.data.result.length > 0) {
        // THIS BLOCK OF CODE HANDLE THE CASE WHERE THERE ARE COMPANIES WITH THE SAME NAME
        registerNetcoreActivity(
          {
            emailAddress: details?.email,
            firstName: details?.firstName,
            lastName: details?.lastName,
            mobileNumber: details?.phoneNumber,
          },
          'Business registration-business name declined',
        );
        setter(res.data);
        setter2(false);
      }
    })
    .catch((err: any) => {
      setLoading(false);
      if (err?.response?.data?.result?.length > 0) {
        setter(err.response.data);
        // THIS BLOCK OF CODE HANDLE THE CASE WHERE THERE ARE COMPANIES WITH THE SAME NAME
        // IF THERE ARE COMPANIES WITH THE SAME NAME
        // SET CHECKS TO FALSE COS IF CHECK IS TRUE
        // IT MEANS THE NAME HAS NOT BEEN USED BEFORE
        setter2(false);
      } else {
        setError(true);
      }
    });
};
